import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { UserCards, Users } from "../../../../Constants/Constants";
import AllCards from "./AllCards";
import { Fragment } from "react/jsx-runtime";

const UsersCardsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={UserCards} parent={Users} />
      <Container fluid>
        <Row>
          <AllCards />
        </Row>
      </Container>
    </Fragment>
  );
};

export default UsersCardsContainer;
